<template>
  <div>
    <template 
      v-for="(set, index) in match.sets.slice().reverse()"
      v-if="set.events && set.events.length > 0">
      <v-list 
        :key="`set_${index}`"
        class="mb-5">
        <v-subheader >
          {{ match.setText }} {{ match.sets.length - index }}
        </v-subheader>
        <template v-for="(event, indexEvent) in set.events.slice().reverse()">
          <v-list-tile 
            :key="`set_${index}_event_${indexEvent}`">
            <v-list-tile-content>
              <template v-if="event.team==='l'">
                <v-list-tile-title>
                  {{ $t(`sport.controls.${event.code}.description`) }}
                  <span v-if="event.player && !['?', '-'].includes(event.player.num)">#{{ event.player.num }}</span>
                  <span v-if="event.extraPlayer && event.extraPlayer.num"> > #{{ event.extraPlayer.num }}</span>
                </v-list-tile-title>
                <v-list-tile-sub-title>
                  <!-- #{{ set.events.length - indexEvent }} -->
                  <span v-if="event.num > 0">
                    [{{ event.l }} - {{ event.v }}]
                  </span>
                  {{ match.localTeam }}
                </v-list-tile-sub-title>
              </template>
              <template v-if="event.team==='v'">
                <v-list-tile-title class="text-xs-right">
                  {{ $t(`sport.controls.${event.code}.description`) }}
                  <span v-if="event.player && !['?', '-'].includes(event.player.num)">#{{ event.player.num }}</span>
                  <span v-if="event.extraPlayer && event.extraPlayer.num"> > #{{ event.extraPlayer.num }}</span>
                </v-list-tile-title>
                <v-list-tile-sub-title class="text-xs-right">
                  {{ match.visitorTeam }}
                  <span v-if="event.num > 0">
                    [{{ event.l }} - {{ event.v }}]
                  </span>
                  <!-- #{{ set.events.length - indexEvent }} -->
                </v-list-tile-sub-title>
              </template>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :key="`set_${index}_event_${indexEvent}_divider`"/>
        </template>
      </v-list>
    </template>
  </div>
</template>

<script>
// const debug = require('debug')('OD::Summary')

export default {
  name: 'Summary',
  components: {},
  props: {
    match: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    modePointControls() {
      return this.mode === 'basic' ? this.match.pointBasicControls : this.match.pointControls
    },
  },
  watch: {},
  created() {},
  beforeDestroy() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
</style>
